import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import VoxelSelect from '../../../components/voxel/Forms/VoxelSelect';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import { currencyList } from '../../../graphql/projects/models/Currencies';
import { CurrencyOptionGq } from '../../../graphql/projects/models/CurrencyOptionGq';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-regular-svg-icons';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

export interface ProjectCurrencyFormState {
  currency: CurrencyOptionGq;
}

export interface CurrencyFormProps {
  project: ProjectGq;
  setDirty: (dirty: boolean) => void;
  reload: () => Promise<unknown>;
  setSave: (saveFunction: () => Promise<unknown>) => void;
}

const CurrencyForm: React.FC<CurrencyFormProps> = ({ project, setDirty, reload, setSave }) => {
  const mutation = projectsApiService.mutations.projects.useUpdateProjectCurrency();
  const formikProps = useFormik<ProjectCurrencyFormState>({
    initialValues: {
      currency: currencyList.find((c) => c.code === project.currency),
    },
    enableReinitialize: true,
    onSubmit: (values, actions) =>
      mutation({ id: project.id, currency: values.currency.code })
        .catch((error) => console.error(error))
        .then(() => reload()),
  });
  useEffect(() => setSave(formikProps.submitForm), [formikProps.submitForm]);

  useEffect(() => {
    setDirty(formikProps.dirty);
    return () => setDirty(false);
  }, [formikProps.dirty]);

  return (
    <VoxelFormPanel
      title={<span>Currency</span>}
      subtitle={
        <span>The currency setting will be used to display monetary values tables and charts.</span>
      }
    >
      <VoxelFormPanelContent>
        <VoxelSelect
          id="currency"
          label="Currency"
          labelPosition="top"
          options={currencyList.map((currency) => ({
            title: currency.code + ' (' + currency.symbol + ')',
            value: currency.code,
          }))}
          selectedOptionValue={formikProps.values?.currency?.code}
          setSelectedOption={(option) =>
            formikProps.setFieldValue(
              'currency',
              currencyList.find((currency) => currency.code === option.value)
            )
          }
          disabled={formikProps.isSubmitting}
        />
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Save changes'}
          onClick={formikProps.submitForm}
          disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
          endIcon={<FontAwesomeIcon icon={faSave} />}
        />
      </VoxelPanelActions>
    </VoxelFormPanel>
  );
};

export default CurrencyForm;
